module.exports = __webpack_public_path__ + "static/media/smokeless_supporter_logo_h.04a69491.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/smokeless_supporter_logo_h.svg
// module id = 275
// module chunks = 0